import { render, staticRenderFns } from "./SolanStudentViewProjectSelect.vue?vue&type=template&id=63fc4c84&scoped=true&"
import script from "./SolanStudentViewProjectSelect.vue?vue&type=script&lang=ts&"
export * from "./SolanStudentViewProjectSelect.vue?vue&type=script&lang=ts&"
import style0 from "./SolanStudentViewProjectSelect.vue?vue&type=style&index=0&id=63fc4c84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc4c84",
  null
  
)

export default component.exports